import {FlowBlockId} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {MobxRequestable} from '@mintdata-wsp/common/util/MobxRequestable';
import {observable} from 'mobx';

export class FocusPropertyRequest
{
    constructor(public readonly blockId:FlowBlockId,
                public readonly propName:string)
    {
    }
}

export class FlowPropertiesPanelState
{
    @observable
    dirtyProperties:IDirtyProperties = {};

    public focusProperty:MobxRequestable<FocusPropertyRequest> = new MobxRequestable();
}

export interface IDirtyProperties
{
    [BlockPropertyKey:string]:boolean;
}
